import axios from '../axios-marketplace';

const getList = (params) => axios.get('/configuracoes-fretes', {
  params,
});
const get = (id) => axios.get(`/configuracoes-fretes/${id}`, {});

const save = (catalogo) => {
  if (catalogo.id) {
    return axios.put(`/configuracoes-fretes/${catalogo.id}`, catalogo);
  }
  return axios.post('/configuracoes-fretes', catalogo);
};

const remover = (id) => axios.delete(`/configuracoes-fretes/${id}`);

const getUrlAutenticacaoMelhorEnvio = () => axios.get('melhor-envio/url-auth');
const getStatusMelhorEnvio = (id) => axios.get(`melhor-envio/fornecedor/${id}/status`);

const vincularContaMelhorEnvio = (id, code) => axios.put(`melhor-envio/fornecedor/${id}/login`, { code });

const logoutMelhorEnvio = (id) => axios.put(`melhor-envio/fornecedor/${id}/logout`, {});

export default {
  getList,
  get,
  save,
  remover,
  getUrlAutenticacaoMelhorEnvio,
  getStatusMelhorEnvio,
  vincularContaMelhorEnvio,
  logoutMelhorEnvio,
};
